import { render } from "./LanguageSelector.vue?vue&type=template&id=4ed45e72&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=4ed45e72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ed45e72"

export default script